import { graphql } from 'react-relay';

import Http3xxRedirectsTable from './containers/Http3xxRedirectsTable';
import Http4xxErrorsTable from './containers/Http4xxErrorsTable';
import Http5xxErrorsTable from './containers/Http5xxErrorsTable';
import HttpStatusCategory from './containers/HttpStatusCategory';
import HttpWithinHttpsTable from './containers/HttpWithinHttpsTable';
import CrawlErrorsTable from './containers/CrawlErrorsTable';

import { createRenderFunction } from '../../utils/redirects';

export default ({
  path: 'http-status',
  Component: HttpStatusCategory,
  query: graphql`
    query httpStatus_HttpStatusCategory_Query($host: String!) {
      project(host: $host) {
        ...HttpStatusCategory_project
      }
    }
  `,
  render: createRenderFunction({ redirectTo: '/5xx-errors' }),
  children: [
    {
      Component: Http5xxErrorsTable,
      path: '5xx-errors',
      query: graphql`
        query httpStatus_HttpStatusCategory_Http5xxErrorsTable_Query($host: String!) {
          project(host: $host) {
            ...Http5xxErrorsTable_project
          }
        }
      `
    },
    {
      Component: Http4xxErrorsTable,
      path: '4xx-errors',
      query: graphql`
        query httpStatus_HttpStatusCategory_Http4xxErrorsTable_Query($host: String!) {
          project(host: $host) {
            ...Http4xxErrorsTable_project
          }
        }
      `
    },
    {
      Component: Http3xxRedirectsTable,
      path: '3xx-redirects',
      query: graphql`
        query httpStatus_HttpStatusCategory_Http3xxRedirectsTable_Query($host: String!) {
          project(host: $host) {
            ...Http3xxRedirectsTable_project
          }
        }
      `
    },
    {
      Component: HttpWithinHttpsTable,
      path: 'http-within-https',
      query: graphql`
        query httpStatus_HttpStatusCategory_HttpWithinHttpsTable_Query($host: String!) {
          project(host: $host) {
            ...HttpWithinHttpsTable_project
          }
        }
      `
    },
    {
      Component: CrawlErrorsTable,
      path: 'crawl-errors',
      query: graphql`
        query httpStatus_HttpStatusCategory_CrawlErrorsTable_Query($host: String!) {
          project(host: $host) {
            ...CrawlErrorsTable_project
          }
        }
      `
    }
  ]
});
